<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h3>{{'not_auth.deleted_doc' | translate}}</h3>
    </div>
    <div class="svg-info-delete">
      <svg width="200px" height="200px" viewBox="0 0 48 48" version="1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 48 48">
        <circle fill="#2196F3" cx="24" cy="24" r="21"/>
        <rect x="22" y="22" fill="#ffffff" width="4" height="11"/>
        <circle fill="#ffffff" cx="24" cy="16.5" r="2.5"/>
      </svg>
    </div>
    <h2>{{'not_auth.no_longer_available' | translate}}</h2>
  </div>
</div>
